<template>
  <el-dialog
    :visible.sync="dialog"
    :title="`${action == 'add' ? '新增' : '编辑'}组织信息`"
    width="45%"
    :top="'15vh'"
    :close-on-click-modal="false"
    class="infoDialog"
  >
    <el-form
      label-width="100px"
      class="onDialog__form"
      :model="form"
      ref="form"
      :rules="rules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="单位名称" prop="deptName">
            <el-input
              v-model="form.deptName"
              size="large"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <template v-if="action == 'add'">
            <el-form-item label="所属区域" prop="districtNameLink">
              <el-cascader
                ref="cascader"
                style="width: 100%"
                v-model="form.districtNameLink"
                :show-all-levels="true"
                :options="deptList"
                size="large"
                :props=newprops
              ></el-cascader>
            </el-form-item>
          </template>
          <template v-if="action != 'add'">
            <el-form-item label="所属区域" prop="parentName">
              <el-select
                :disabled="true"
                style="width: 100%"
                :value="form.parentName"
                size="large"
              ></el-select>
            </el-form-item> </template></el-col>

        <template v-if="deptInfo.deptType == 6 || deptInfo.deptType == 2">
          <el-col :span="12">
            <el-form-item label="负责人" prop="roleId">
              <el-input
                v-model="form.manager"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="telephone">
              <el-input
                v-model="form.telephone"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="单位定位" prop="phone">
              <el-input
                v-model="form.lngLat"
                placeholder="请输入经纬度(经度，纬度)"
                size="large"
              >

              </el-input>
            </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="单位标签" prop="deptId">
              <el-cascader
                style="width: 100%"
                size="large"
                :show-all-levels="false"
                v-model="form.deptLabels"
                :options="labelTree"
                :props="props"
                @change="handleLabels"
                clearable
              ></el-cascader></el-form-item
          ></el-col>
        </template>
      </el-row>
    </el-form>
    <template v-if="deptInfo.deptType == 6 || deptInfo.deptType == 2">
      <div class="mapGroup">
        <cmap :form="form" @MapObj="getPoi"></cmap>
        <!--      <div id="map3"></div>-->
        <!--      <div id="pickerBox">-->
        <!--        <input-->
        <!--          id="pickerInput"-->
        <!--          placeholder="输入关键字选取地点"-->
        <!--          v-model="userInput"-->
        <!--        />-->
        <!--        <button type="primary" @click="biu">确定选址</button>-->
        <!--      </div>-->
      </div>
    </template>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="dialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Axios from "../../../../utils/Axios";
import cmap from "./bmap";
export default {
  name: "orgEditDialog",
  props: {
    editDialog: {
      type: Boolean,
      default: false,
    },
    deptInfo: {
      type: Object,
      default: () => {},
    },
    action: {
      type: String,
      default: "add",
    },
    parentNode: {
      type: Object,
      default: () => {},
    },
  },
  components: { cmap },
  data() {
    let that = this;
    let validateInput = (rule, value, callback) => {
      if (!this.checkSpecialKey(value)) {
        callback(new Error("不能含有特殊字符"));
      } else {
        callback();
      }
    }
    return {
      map: null,
    realprops:{ children: 'districts', value: 'name', label: 'name' },
      autoOptions: {
        input: "pickerInput", //绑定的搜索关键字的input标签ID，用这个注册
      },
      oldlevel:null,
      newprops: {
        lazy: true,
        lazyLoad (node, resolve) {

          if(node.root){

          }else{
            if(node.data.level!="district" ){
              setTimeout(() => {



                that.lazyLoad(node, resolve)
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                // resolve(nodes);
              }, 100);
            }else{
              resolve()
            }

          }

        },
        children: 'districts',
        value: 'name',
        label: 'name',
        checkStrictly: false,
      },
      auto: null,
      userInput: "", //绑定的搜索关键字的的内容
      placeSearch: null,
      searchHere: null, //根据搜索组件搜索到以后的地点信息
      props: {
        checkStrictly: true,
        multiple: true,
        value: "id",
        label: "name",
        // lazy: true,
        // lazyLoad: that.lazyLoad,
      },
      rules: {
        deptName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
          { validator: validateInput, trigger: ['blur', 'change']  },//加上这一句
        ],
        districtNameLink: [
          {
            type: "array",
            required: true,
            message: "请选择区域",
            trigger: "blur",
          },
        ],
        parentDeptName: [
          {
            required: true,
            message: "请选择区域",
            trigger: "blur",
          },
        ],
      },
      typeList: [],
      roleList: [],
      deptList: [],
      labelTree: [],
      latLng: "",
      form:
        this.action == "add"
          ? { districtNameLink: "", lngLat: "" }
          : JSON.parse(JSON.stringify(this.deptInfo)), //父组件传递给子组件值的时候，传递的是地址；不能直接修改，必须深拷贝
    };
  },
  watch: {},
  computed: {
    dialog: {
      get: function () {
        return this.editDialog;
      },
      set: function (newValue) {
        this.$emit("update:editDialog", newValue);
      },
    },
  },
  methods: {


    lazyLoad(node, resolve) {
      if( node.data.level!=this.oldlevel){
        this.twoqueryDistricts(node,resolve)
      }



    },
    twoqueryDistricts(data,resolve) {

      const row = {
        districtName: data.data.name,
        parentAdcode: Number(data.data.adcode),
        subNo: 1,
      };

      Axios.ajax({
        url: "/dept/getDistricts",
        method: "post",
        data: row,
      }).then((res) => {

        this.oldlevel=res.data[0].level
        // resolve(res.data[0].districts);
        if(res.data[0].level=="city"){
          console.log(res.data[0])
          let arr=res.data[0].districts

          resolve(
            arr.map(item => {

              item.leaf = 'leaf'//这个必须加，就是让组件识别是不是最后一级

              return item

            })

          )
        }else{
          resolve(res.data[0].districts);
        }

      });
    },
    checkSpecialKey(str) {
      let specialKey = "[.。'<{}>]";
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    getPoi(obj) {
      console.log(obj)
      this.form.lngLat = obj;
    },
    confirm() {
      this.$refs.form.validate((va) => {

        let lngLat = [];
        if(this.form.lngLat){
          lngLat = this.form.lngLat.split(",");
        }else{

        }
        const deptLabels = [];
        if (Array.isArray(this.form.deptLabels)) {
          for (let i = 0; i < this.form.deptLabels.length; i++) {
            for (let j = 0; j < this.form.deptLabels[i].length; j++) {
              if (j == this.form.deptLabels[i].length - 1) {
                deptLabels.push(this.form.deptLabels[i][j]);
              }
            }
          }
        }
        if (va) {
          if (this.action == "add") {
            if(this.form.districtNameLink.length==1){

            }else{
              this.form.districtNameLink.shift()
            }

            let districtNameLink= this.form.districtNameLink.join(",")


            const data = {
              districtNameLink:districtNameLink,

              parentId: this.deptInfo.issolo?this.deptInfo.parentId:this.deptInfo.deptId,
              deptName: this.form.deptName,
              manager: this.form.manager,
              telephone: this.form.telephone,
              deptLabels: Array.isArray(this.form.deptLabels)
                ? deptLabels.toString()
                : this.form.deptLabels,
              lat: lngLat.length ? lngLat[1] :null,
              lng: lngLat.length ? lngLat[0] :null,
              deptType: 6,
            };
            Axios.ajax({
              url: "/dept/addDistrict",
              method: "post",
              data: data,
            }).then((res) =>
            {
              if (res.resultCode == 0) {
                this.dialog = false;
                this.$emit("update");
                this.$message.success("新增成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          } else {

            const data = {
              deptId: this.deptInfo.deptId,
              deptName: this.form.deptName,
              manager: this.form.manager,
              telephone: this.form.telephone,
              deptLabels: Array.isArray(this.form.deptLabels)
                ? deptLabels.toString()
                : this.form.deptLabels,
              lat: lngLat.length && lngLat[1]!='null' ? lngLat[1]: null,
              lng: lngLat.length && lngLat[0]!='null' ? lngLat[0] :null,
              deptType: this.deptInfo.deptType,
            };
            Axios.ajax({
              url: "/dept/update",
              method: "post",
              data: data,
            }).then((res) => {
              if (res.resultCode == 0) {
                this.dialog = false;
                this.$emit("update");
                this.$message.success("编辑成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          }
        }
      });
    },
    queryDistricts(data) {
      const row = {
        districtName: data.childrenName == "全国" ? "" : data.childrenName,
        parentAdcode: Number(data.districtCode) || "",
        subNo: 1,
      };
      Axios.ajax({
        url: "/dept/getDistricts",
        method: "post",
        data: row,
      }).then((res) => {

        this.deptList = this.handleList(res.data);
      });
    },
    handleLabels(arr) {
      //网上贴的方法 有bug  //可以单选 但是必须取消之前选中的
      console.log(arr, "old"); //此时的arr就是选择之后的级联选择器的结果，是个数组组成的数组。
      if (arr.length) {
        let newArr = [arr[0]]; //取第一个作为一个新的数组[[2,1],[2,2],[2,3]],这样的结果需要改为[[2,1]]，后面的几个数组都不要选中。
        for (let i = 1; i < arr.length; i++) {
          if (arr[i][0] !== newArr[newArr.length - 1][0]) {
            //判断数组中的第一项是否相等
            newArr.push(arr[i]); //如果不相等，则添加到数组中，否则不进行处理
          } else {
            this.$message.warning("请先取单击选中节点，取消已选中节点！");
          }
        }
        this.form.deptLabels = newArr; //这个dailiArr就是级联选择器的结果
      }
    },
    handleList(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].districts.length < 1 || data[i].level == "district") {
          // children若为空数组，则将children设为undefined
          data[i].districts = undefined;
        } else {
          // children若不为空数组，则继续递归调⽤本⽅法
          this.handleList(data[i].districts);
        }
      }
      return data;
    },
    biu() {
      if (this.searchHere) {
        this.$message({
          message: "确认地点：" + this.searchHere.name,
          type: "success",
        });
        // this.$emit('mapHere',this.searchHere);

        alert(
          `地址数据都在data里面this.searchHere，包括经纬度，以及其他各种地址信息，该有的都有，当poi搜索以后select(e){}方法里面的参数e就是地址信息，我把单独拿出来。地点名：` +
            this.searchHere.name
        );
      }
    },
    queryLabelTree() {
      Axios.ajax({
        url: "/label/tree",
        method: "get",
      }).then(({ data }) => {
        this.labelTree = data;
      });
    },
  },
  created() {
    this.queryLabelTree();
  },
  mounted() {
    console.log(this.form.lngLat)
    if(this.form.lngLat=='null,null' || this.form.lngLat==',null'){
      this.form.lngLat=''
    }

    this.$nextTick(() => {
      this.queryDistricts(this.parentNode);
      // this.initMap(this.form);
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
#pickerBox {
  position: absolute;
  z-index: 9999;
  top: 20px;
  left: 20px;
  width: 300px;
}
#pickerInput {
  width: 200px;
  padding: 5px 5px;
}
#poiInfo {
  background: #fff;
}
.mapGroup {
  height: 290px;
  position: relative;
}
.infoDialog {
}
</style>
